/* KIWABI mobile editorial copy enhancements; no fixed menu or preview offset. */
(()=>{'use strict';
 const mq=window.matchMedia('(max-width:700px)');
 const style=document.createElement('style');
 style.textContent='@media(max-width:700px){.kw-site.kw-japan .kj-intro h1{font-size:clamp(24px,7.2vw,30px);text-wrap:balance}}';
 document.head.append(style);
 const normalize=()=>{
  if(!mq.matches)return;
  document.querySelectorAll('.km-teaser').forEach(e=>{
   const spaced=e.textContent.replace(/([.!?])([ぁ-んァ-ン一-龯])/g,'$1 $2');
   if(spaced!==e.textContent)e.textContent=spaced;
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',normalize,{once:true});else normalize();
 document.addEventListener('shopify:section:load',normalize);
 if(mq.addEventListener)mq.addEventListener('change',normalize);
})();